import $ from "jquery";
import refresh_token from "./ajax_redirects/refresh_token.js";

function ajaxWrapper(type, url, data, return_func, fail_func, return_func_params) {
	if (window.location.hostname === "localhost" && !url.includes(":8000")) {
		url = "http://localhost:8000" + url;
	}

	if (type === "POST" || type === "PUT") {
		data = JSON.stringify(data);
	}

	let authToken = "";
	let beforeSend = null;
	if (localStorage.getItem("token")) {
		authToken = `Bearer ${localStorage.getItem("token")}`;
		beforeSend = (request) => request.setRequestHeader("Authorization", authToken);
	}

	$.ajax({
		type: type,
		url: url,
		contentType: "application/json",
		beforeSend: beforeSend,
		data: data,
		statusCode: {
			200(value) {
				console.log("return!");
				console.log(value);
				if (value !== null && typeof value === "object" && "redirect" in value) {
					window.location = `${value.redirect}?redirect=${window.secret_react_state.BASE_URL}`;
				}
				return_func(value);
			},
			400(value) {
				value = { error: "Bad Request" };
				return_func(value);
			},
			401(xhr) {
				if (url.endsWith("/user/token/")) {
					let value = { error: "Invalid Credentials" };
					return_func(value);
				} else {
					refresh_token(type, url, data, xhr.responseJSON, return_func);
				}
			},
			404() {
				value = { error: "URL Not Found" };
				return_func(value);
			},
			408(value) {
				value = { error: "Request Timed Out" };
				return_func(value);
			},
			500(value) {
				value = { error: "Server Error" };
				return_func(value);
			},
		},
	});
}

export default ajaxWrapper;
